import React, { useState, useEffect } from 'react';
// import SettingsIcon from './../../assets/svgs/NavBarIcons/SettingsIcon.svg';
// import SearchIcon from './../../assets/svgs/NavBarIcons/SearchIcon.svg';
// import NotificationsIcon from './../../assets/svgs/NavBarIcons/NotificationsIcon.svg';
import { Dropdown, Typography } from 'antd';
import type { MenuProps } from 'antd';
import { UserOutlined, LockOutlined, LogoutOutlined } from '@ant-design/icons';
import useAxiosPost from '../../hooks/useAxiosPost';
import { useNavigate } from 'react-router-dom';
import { getUserType, handleLogout } from '../../helpers/userDetails';

// const navItems: NavItem[] = [
//   { label: 'Settings', url: '/settings', icon: SettingsIcon },
//   { label: 'Search', url: '/search', icon: SearchIcon },
//   { label: 'Notification', url: 'notifications', icon: NotificationsIcon },
// ];

const TopNavBar = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState<string>('');

  // Fetch user profile
  const [postGetProfile, getProfileResponse, getProfileError, getProfileLoading] =
    useAxiosPost<ResponseProp>('auth/getProfile');

  // Fetch master staff profile
  const [
    postGetMasterStaffProfile,
    getMasterStaffProfileResponse,
    getMasterStaffProfileError,
    getMasterStaffProfileLoading,
  ] = useAxiosPost<ResponseProp>('master-staff-auth/getProfile');

  // Fetch profile on mount
  useEffect(() => {
    const userType = getUserType();
    if (userType === 'MASTER_ADMIN' || userType === 'MASTER_NOC') {
      postGetMasterStaffProfile({});
    } else {
      postGetProfile({});
    }
  }, []);

  // Update userName when profile is fetched
  useEffect(() => {
    if (getProfileResponse !== null) {
      const data: any = getProfileResponse.responseData;
      if (data?.fullName) {
        setUserName(data.fullName);
      }
    }
  }, [getProfileResponse]);

  // Update userName when master staff profile is fetched
  useEffect(() => {
    if (getMasterStaffProfileResponse !== null) {
      const data: any = getMasterStaffProfileResponse.responseData;
      if (data?.fullName) {
        setUserName(data.fullName);
      }
    }
  }, [getMasterStaffProfileResponse]);

  const userType = getUserType();
  const menuItems: MenuProps['items'] = [
    {
      key: '1',
      label: 'Update Profile',
      icon: <UserOutlined />,
      onClick: () => {
        if (userType === 'MASTER_ADMIN') {
          navigate('/auth/masterstaff/update-profile');
        } else {
          navigate('/edit-profile');
        }
      },
    },
    {
      key: '2',
      label: 'Update Password',
      icon: <LockOutlined />,
      onClick: () => {
        if (userType === 'MASTER_ADMIN') {
          navigate('/auth/masterstaff/update-password');
        } else {
          navigate('/change-password');
        }
      },
    },
    {
      key: '3',
      label: 'Logout',
      icon: <LogoutOutlined />,
      onClick: () => {
        handleLogout();
      },
    },
  ];

  return (
    <>
      <div className="top-nav-bar-items-container">
        {/* {navItems.map((item: NavItem) => {
          return (
            <div key={Math.random()} className="top-nav-bar-item">
              {<img src={item.icon} />}
            </div>
          );
        })} */}
        <Dropdown menu={{ items: menuItems }} trigger={['click']}>
          <div
            style={{
              cursor: 'pointer',
              padding: '4px 12px',
              borderRadius: '4px',
              border: '1px solid #d9d9d9',
              minWidth: '150px',
              textAlign: 'center',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography.Text>{userName}</Typography.Text>
          </div>
        </Dropdown>
      </div>
    </>
  );
};

export default TopNavBar;
